var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Vue, Prop } from 'vue-property-decorator';
import { User } from '@/models/User';
import Roster from '@/components/roster/Roster';
import NotificationsCard from '@/components/notifications-card/NotificationsCard';
import { UserSubject } from '@/models/UserSubject';
import DataTable from '@/components/data-table/DataTable';
import { formatDate as format, ratingStarHtml } from '@/support/String';
import { excludeRoles } from '@/support/ExcludeRoles';
import Idp from '@/views/Users/Student/Idps/Idp';
import { Student } from '@/models/Student';
import ErrorHandler from '@/support/ErrorHandler';
let Dashboard = class Dashboard extends Vue {
    constructor() {
        super(...arguments);
        this.student = new Student();
    }
    get userSubjectsTableOptions() {
        return {
            sort: {
                key: 'updated',
                order: 'DESC',
            },
            headers: [
                {
                    text: this.$tc('subject.title', 2),
                    value: 'name',
                    action: `/students/${this.user.id}/idp`,
                },
                {
                    text: this.$tc('subject.area.title', 2),
                    value: 'parent',
                    transform: this.areaName,
                },
                {
                    text: this.$tc('subject.topic.title', 2),
                    value: 'parent',
                    transform: this.parentName,
                },
                {
                    text: this.$tc('idp.status.finished', 2),
                    value: 'updated_at',
                    transform: (date) => {
                        return format(date, 'yyyy-LL-dd');
                    },
                },
                {
                    text: this.$t('subject.rating'),
                    value: 'rating',
                    transform: this.starRating,
                },
            ],
            actions: [
                {
                    type: 'view',
                    label: 'view',
                    icon: 'remove_red_eye',
                    action: (vm, userSubject) => {
                        this.$router.push(`/students/${userSubject.user}?subject=${userSubject.id}`);
                    },
                },
            ],
            model: new UserSubject()
                .user(this.user)
                .include('parent')
                .filter({
                users: this.user ? [this.user.id] : null,
                statuses: ['finished'],
            }),
        };
    }
    get exclude() {
        return excludeRoles[this.$store.state.version].scoolUsers.dashboard.includes(this.$store.state.Auth.roles[0].id);
    }
    mounted() {
        if (this.exclude) {
            this.fetchStudent();
        }
    }
    starRating(element) {
        let innerHtml = '';
        if (element > 0) {
            const stars = (element / 20) - 1;
            for (let i = 0; i <= stars; i++) {
                innerHtml += ratingStarHtml();
            }
            return innerHtml;
        }
        return innerHtml = '';
    }
    areaName(element) {
        // TODO: STEFANO FIXES
        if (!element.id) {
            return '';
        }
        let name = '';
        this.$store.state.curriculum.subjects.forEach((area) => {
            if (!area.children) {
                return;
            }
            area.children.forEach((topic) => {
                if (topic.id === element.id && area.name) {
                    name = area.name;
                }
            });
        });
        return name;
    }
    parentName(element) {
        return element.name ? element.name : '';
    }
    fetchStudent() {
        new Student()
            .find(this.user.id)
            .then((student) => {
            this.student = student;
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
};
__decorate([
    Prop({ default: new User() }),
    __metadata("design:type", typeof (_a = typeof User !== "undefined" && User) === "function" ? _a : Object)
], Dashboard.prototype, "user", void 0);
Dashboard = __decorate([
    Component({
        components: {
            DataTable,
            NotificationsCard,
            Roster,
            Idp,
        },
    })
], Dashboard);
export default Dashboard;
